import { render, staticRenderFns } from "./EditBlockSlideshowSettingsTabStyle.vue?vue&type=template&id=bbd79232&scoped=true&"
import script from "./EditBlockSlideshowSettingsTabStyle.vue?vue&type=script&lang=js&"
export * from "./EditBlockSlideshowSettingsTabStyle.vue?vue&type=script&lang=js&"
import style0 from "./EditBlockSlideshowSettingsTabStyle.vue?vue&type=style&index=0&id=bbd79232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd79232",
  null
  
)

export default component.exports